import {
  takeLatest, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* setRate() {
  try {
    yield call(api, {
      method: 'get',
      url: URL.TRIAL,
    });
    yield call(toast.success, 'Your trial period expires in 7 days.');
  } catch (e) {
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_TRIAL, setRate);
}
